'use strict';

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errCode = require('err-code');

var browserStreamToIt = require('browser-readablestream-to-it');

var itPeekable = require('it-peekable');

var utils = require('./utils.js');

var ipfsUnixfs = require('ipfs-unixfs');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default =
/*#__PURE__*/
_interopDefaultLegacy(errCode);

var browserStreamToIt__default =
/*#__PURE__*/
_interopDefaultLegacy(browserStreamToIt);

var itPeekable__default =
/*#__PURE__*/
_interopDefaultLegacy(itPeekable);

function normaliseCandidateSingle(_x, _x2) {
  return _normaliseCandidateSingle.apply(this, arguments);
}

function _normaliseCandidateSingle() {
  _normaliseCandidateSingle = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(input, normaliseContent) {
    var peekable, _ref, value, done;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(input === null || input === undefined)) {
              _context.next = 2;
              break;
            }

            throw errCode__default["default"](new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');

          case 2:
            if (!(typeof input === 'string' || input instanceof String)) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return toFileObject(input.toString(), normaliseContent);

          case 5:
            return _context.abrupt("return");

          case 6:
            if (!(utils.isBytes(input) || utils.isBlob(input))) {
              _context.next = 10;
              break;
            }

            _context.next = 9;
            return toFileObject(input, normaliseContent);

          case 9:
            return _context.abrupt("return");

          case 10:
            if (utils.isReadableStream(input)) {
              input = browserStreamToIt__default["default"](input);
            }

            if (!(Symbol.iterator in input || Symbol.asyncIterator in input)) {
              _context.next = 28;
              break;
            }

            peekable = itPeekable__default["default"](input);
            _context.next = 15;
            return _awaitAsyncGenerator(peekable.peek());

          case 15:
            _ref = _context.sent;
            value = _ref.value;
            done = _ref.done;

            if (!done) {
              _context.next = 22;
              break;
            }

            _context.next = 21;
            return {
              content: []
            };

          case 21:
            return _context.abrupt("return");

          case 22:
            peekable.push(value);

            if (!(Number.isInteger(value) || utils.isBytes(value) || typeof value === 'string' || value instanceof String)) {
              _context.next = 27;
              break;
            }

            _context.next = 26;
            return toFileObject(peekable, normaliseContent);

          case 26:
            return _context.abrupt("return");

          case 27:
            throw errCode__default["default"](new Error('Unexpected input: multiple items passed - if you are using ipfs.add, please use ipfs.addAll instead'), 'ERR_UNEXPECTED_INPUT');

          case 28:
            if (!utils.isFileObject(input)) {
              _context.next = 32;
              break;
            }

            _context.next = 31;
            return toFileObject(input, normaliseContent);

          case 31:
            return _context.abrupt("return");

          case 32:
            throw errCode__default["default"](new Error('Unexpected input: cannot convert "' + typeof input + '" into ImportCandidate'), 'ERR_UNEXPECTED_INPUT');

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _normaliseCandidateSingle.apply(this, arguments);
}

function toFileObject(_x3, _x4) {
  return _toFileObject.apply(this, arguments);
}

function _toFileObject() {
  _toFileObject = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(input, normaliseContent) {
    var path, mode, mtime, content, file;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            path = input.path, mode = input.mode, mtime = input.mtime, content = input.content;
            file = {
              path: path || '',
              mode: ipfsUnixfs.parseMode(mode),
              mtime: ipfsUnixfs.parseMtime(mtime)
            };

            if (!content) {
              _context2.next = 8;
              break;
            }

            _context2.next = 5;
            return normaliseContent(content);

          case 5:
            file.content = _context2.sent;
            _context2.next = 12;
            break;

          case 8:
            if (path) {
              _context2.next = 12;
              break;
            }

            _context2.next = 11;
            return normaliseContent(input);

          case 11:
            file.content = _context2.sent;

          case 12:
            return _context2.abrupt("return", file);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _toFileObject.apply(this, arguments);
}

exports.normaliseCandidateSingle = normaliseCandidateSingle;